<template>
  <div class="wrapper">
    <dashboard-bar refreshButton />
    <div class="wrapp">
      <div class="row">
        <div class="col-lg-2" refreshButton>
          <span class="header-icon">
            <font-awesome-icon :icon="['fas', 'sync-alt']" />
          </span>
          <h2>{{ $t('answers.pageTitle') }}</h2>
        </div>
      </div>
      <treatment-table :isAnswerMenu="true" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import treatmentTable from '@/components/molecules/treatment-table';
import dashboardBar from '@/components/molecules/dashboard-bar';

export default {
  components: { treatmentTable, dashboardBar },

  data: () => ({
    userAuth: null,
  }),

  computed: {
    ...mapState('authentication', ['userProfile']),
  },

  mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  created() {
    if (!this.userProfile.permissions.answers.menu) {
      this.$router.push(`/dashboard/${this.userAuth.companyId}`);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.wrapper {
  padding: 8px;
}

.wrapp {
  background-color: $white;
  padding: 16px;
  border: 1px solid $gray-light;
  border-radius: 4px;
}

.wrapp h2 {
  text-transform: uppercase;
  font-size: 21px;
  font-weight: 100;
  color: $gray;
}

.header-icon {
  float: left;
  font-size: 12px;
  margin-top: 4px;
  padding-right: 12px;
  color: $gray;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/answers/index.vue